import { render, staticRenderFns } from "./WebLink.vue?vue&type=template&id=0268d510&"
import script from "./WebLink.vue?vue&type=script&lang=js&"
export * from "./WebLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports